module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_9016.43751e50.png";